import { render, staticRenderFns } from "./page-search-form.vue?vue&type=template&id=a01564a4&scoped=true"
import script from "./page-search-form.vue?vue&type=script&lang=js"
export * from "./page-search-form.vue?vue&type=script&lang=js"
import style0 from "./page-search-form.styl?vue&type=style&index=0&id=a01564a4&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a01564a4",
  null
  
)

export default component.exports